import { css } from '@emotion/react';
import { FC } from 'react';
import { colors } from '../../styles';

interface Props {
  checked: boolean;
  onChange: () => void;
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
}

const getToggleSwitchStyles = (size: 'small' | 'medium' | 'large' = 'medium', disabled = false) => {
  const sizeConfig = {
    small: { width: 48, height: 28, knobSize: 20, knobOffset: 4, translateX: 20 },
    medium: { width: 60, height: 34, knobSize: 26, knobOffset: 4, translateX: 26 },
    large: { width: 72, height: 40, knobSize: 32, knobOffset: 4, translateX: 32 },
  };

  const config = sizeConfig[size];

  return css`
    position: relative;
    display: inline-block;
    width: ${config.width}px;
    height: ${config.height}px;
    flex-shrink: 0;
    opacity: ${disabled ? 0.6 : 1};
    cursor: ${disabled ? 'not-allowed' : 'pointer'};

    input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    span {
      position: absolute;
      cursor: ${disabled ? 'not-allowed' : 'pointer'};
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: ${disabled ? '#e0e0e0' : '#ccc'};
      transition: 0.4s;
      border-radius: ${config.height}px;

      &:before {
        position: absolute;
        content: '';
        height: ${config.knobSize}px;
        width: ${config.knobSize}px;
        left: ${config.knobOffset}px;
        bottom: ${config.knobOffset}px;
        background-color: white;
        transition: 0.4s;
        border-radius: 50%;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      }
    }

    input:checked + span {
      background-color: ${disabled ? '#a0a0a0' : colors.petrolBlue};
    }

    input:checked + span:before {
      transform: translateX(${config.translateX}px);
    }

    &:hover span {
      box-shadow: ${disabled ? 'none' : '0 0 8px rgba(0, 0, 0, 0.1)'};
    }
  `;
};

const ToggleSwitch: FC<Props> = ({ checked, onChange, size = 'medium', disabled = false }) => (
  <label css={getToggleSwitchStyles(size, disabled)}>
    <input type="checkbox" checked={checked} onChange={disabled ? undefined : onChange} disabled={disabled} />
    <span></span>
  </label>
);

export default ToggleSwitch;
